
import { defineComponent, computed, PropType } from 'vue'
import MoreInfo from '@/components/common/MoreInfo.vue'
import dayjs from 'dayjs'
import { fromDecimalToUnit } from '@/libs/everpay-js/utils/util'
import { getExplorerUrl, formatNumber, formatMoney } from '@/libs/utils'
import { ChainType, Token } from '@/libs/everpay-js'
import { useI18n } from 'vue-i18n'
import SimpleWrapper from './SimpleWrapper.vue'
import capitalize from 'lodash/capitalize'
export default defineComponent({
  components: {
    MoreInfo,
    SimpleWrapper
  },
  props: {
    timeNonce: {
      type: Number,
      default: 0
    },
    action: {
      type: String,
      default: ''
    },
    owner: {
      type: String,
      default: ''
    },
    rollupTxNum: {
      type: Number,
      default: 0
    },
    amount: {
      type: String,
      default: ''
    },
    tokenSymbol: {
      type: String,
      default: ''
    },
    token: {
      type: Object as PropType<Token | undefined>,
      default: () => ({})
    },
    isArid: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { t } = useI18n()
    const datetime = computed(() => {
      return dayjs(+props.timeNonce).format('YYYY-MM-DD HH:mm:ss')
    })
    const type = computed(() => {
      if (props.action === 'mint') return 'deposit'
      if (props.action === 'burn') return 'withdraw'
      return props.action
    })
    const miner = computed(() => {
      return `${props.owner.slice(0, 4)}...${props.owner.slice(-4)}`
    })
    const minnnerUrl = getExplorerUrl({
      type: 'address',
      value: props.owner
    }, ChainType.arweave)
    const totalAmount = computed(() => {
      return fromDecimalToUnit(props.amount, props.token?.decimals || 18)
    })
    const replaceAmountLenght = computed(() => {
      return totalAmount.value.replaceAll(',', '').replace('.', '').length
    })
    const formatTotalAmount = computed(() => {
      if (replaceAmountLenght.value > 6) {
        return formatNumber(totalAmount.value, 6) + '...' + props.tokenSymbol.toUpperCase()
      }
      return formatMoney(totalAmount.value) + ' ' + props.tokenSymbol.toUpperCase()
    })
    return {
      t,
      datetime,
      formatTotalAmount,
      miner,
      type,
      minnnerUrl,
      totalAmount,
      capitalize,
      replaceAmountLenght
    }
  }
})
